import { isEmpty, omitBy } from 'lodash';
import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export type QueryParameters = Record<string, string>;

export function useParameters(): {
  parameters: QueryParameters;
  setParameters: typeof setSearchParameters;
  resetParameters: typeof resetSearchParameters;
} {
  const { search } = useLocation();
  const navigate = useNavigate();
  const searchParameters = Object.fromEntries(new URLSearchParams(search));

  const setSearchParameters = useCallback(
    (parametersObject: QueryParameters) => {
      const newParameters = omitBy(parametersObject, isEmpty);
      navigate(
        {
          search: `?${new URLSearchParams(newParameters).toString()}`,
        },
        { replace: true },
      );
    },
    [navigate],
  );

  const resetSearchParameters = useCallback(() => {
    navigate(
      {
        search: ``,
      },
      { replace: true },
    );
  }, [navigate]);

  return {
    setParameters: setSearchParameters,
    parameters: searchParameters,
    resetParameters: resetSearchParameters,
  };
}
